import {
  PlatformAppsAdmin,
  ProjectAvailability as ProjectAvailabilityAdmin,
  ProjectCodesAdmin,
  PropertyDefinitionsAdmin,
  SupportingDocumentTypesAdmin,
  TherapyAreasAdmin,
} from "@lumanity/ui/projects";
import { toast } from "@lumanity/ui/primitives";
import { ROLE_PROPERTY_KEYS } from "@/features/team/teamApi";
import { MODEL_LABELS } from "@/lib/models";

// Admin pages that are the library's components as-is, wired to PubCreator's toasts.

const showError = (error: Error) => toast({ title: "Something went wrong", description: error.message, variant: "destructive" });
const showSuccess = (message: string) => toast({ title: message });

export const TherapyAreas = () => <TherapyAreasAdmin onError={showError} />;

export const ProjectCodes = () => <ProjectCodesAdmin onError={showError} />;

export const SupportingDocumentTypes = () => <SupportingDocumentTypesAdmin onError={showError} />;

// Workflow roles are properties too, but they're set from the Team panel.
export const ProjectProperties = () => (
  <PropertyDefinitionsAdmin
    onChanged={showSuccess}
    onError={showError}
    optionLabels={{ model: MODEL_LABELS }}
    readOnlyKeys={ROLE_PROPERTY_KEYS}
  />
);

export const RegisteredApps = () => <PlatformAppsAdmin onChanged={showSuccess} onError={showError} />;

export const ProjectAvailability = () => (
  <ProjectAvailabilityAdmin
    onChanged={(c) => showSuccess(c.available ? `${c.projectName} is now available in ${c.appName}` : `${c.projectName} removed from ${c.appName}`)}
    onError={showError}
  />
);
